import { asyncToGenerator as _asyncToGenerator, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { API_REQUEST } from './actions.js';
import { ajaxActionsFor } from './ajax.js';
import { MOCK_REQUEST } from './mocks.js';
import { apiRequest } from './request.js';
import { ApiError } from './errors.js';
import { getApiModuleOptions } from './config.js';
import { DebounceMap } from '../utility/debounce.js';
import { onApiRequest } from '../auth/events.js';

var apiRequestHandler = function apiRequestHandler(store, action, options, resolve) {
  var actionData = {};

  if (action.actionCustomData) {
    actionData.customData = action.actionCustomData;
  }

  var req = ajaxActionsFor(action.requestType, actionData); // function to perform any pre-request actions

  var beforeRequest = function beforeRequest() {
    store.dispatch(req.start({
      method: action.method,
      url: action.url,
      contentType: action.contentType,
      body: action.body,
      auth: action.auth
    }));

    if (action.actionSlowDelay) {
      store.dispatch(req.slow(action.actionSlowDelay));
    }
  }; // function to perform the request and subsequent actions


  var dispatchRequest = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var requestOptions,
          response,
          error,
          onErrorNotification,
          reason,
          _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              requestOptions = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              response = undefined;
              _context.prev = 2;
              _context.next = 5;
              return apiRequest(action.method, action.url, _objectSpread2(_objectSpread2({}, requestOptions), {}, {
                headers: _objectSpread2(_objectSpread2({}, requestOptions.headers), action.headers),
                contentType: action.contentType,
                body: action.body,
                preventResponseHandling: getApiModuleOptions().preventResponseHandling || action.preventResponseHandling,
                abort: action.abort
              }));

            case 5:
              response = _context.sent;
              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);

              if (_context.t0 instanceof ApiError) {
                error = _context.t0;
                onErrorNotification = getApiModuleOptions().onErrorNotification;
                store.dispatch(req.error(error));

                if (!getApiModuleOptions().preventErrorNotification && !action.preventErrorNotification && onErrorNotification) {
                  store.dispatch(onErrorNotification(error.message));
                }

                resolve({
                  success: false,
                  error: error
                });
              } else {
                reason = typeof _context.t0 === "string" ? _context.t0 : undefined;
                store.dispatch(req.abort(reason));
                resolve({
                  success: false,
                  reason: reason
                });
              }

              return _context.abrupt("return");

            case 12:
              store.dispatch(req.success(response));
              resolve({
                success: true,
                response: response
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 8]]);
    }));

    return function dispatchRequest() {
      return _ref.apply(this, arguments);
    };
  }(); // process the api request


  beforeRequest();
  onApiRequest(store, action).then(function (requestOptions) {
    dispatchRequest(requestOptions);
  }).catch(function (error) {
    store.dispatch(req.error(error));
    resolve({
      success: false,
      error: error
    });
  });
};

var mockRequestHandler = function mockRequestHandler(store, action, options, resolve) {
  var actionData = {};

  if (action.actionCustomData) {
    actionData.customData = action.actionCustomData;
  }

  var req = ajaxActionsFor(action.requestType, actionData); // function to perform any pre-request actions

  var beforeRequest = function beforeRequest() {
    store.dispatch(req.start({
      method: "MOCK",
      success: action.success,
      response: action.response,
      error: action.error,
      delay: action.delay
    }));

    if (action.actionSlowDelay) {
      store.dispatch(req.slow(action.actionSlowDelay));
    }
  }; // function to perform the request and subsequent actions


  var dispatchRequest = function dispatchRequest() {
    if (action.success) {
      store.dispatch(req.success(action.response));
      resolve({
        success: true,
        response: action.response
      });
    } else if (action.error != undefined) {
      var errorResponse = new ApiError(action.error);
      var onErrorNotification = getApiModuleOptions().onErrorNotification;
      store.dispatch(req.error(errorResponse));

      if (!getApiModuleOptions().preventErrorNotification && !action.preventErrorNotification && onErrorNotification) {
        store.dispatch(onErrorNotification(errorResponse.message));
      }

      resolve({
        success: false,
        error: errorResponse
      });
    }
  }; // process the api request


  beforeRequest();
  var rejected = false;

  if (action.abort !== undefined) {
    var onAbort = function onAbort(reason) {
      var _action$abort;

      rejected = true;
      (_action$abort = action.abort) === null || _action$abort === void 0 ? void 0 : _action$abort.removeListener(onAbort);
      store.dispatch(req.abort(reason));
      resolve({
        success: false,
        reason: reason
      });
    };

    action.abort.addListener(onAbort);
  }

  if (action.delay) {
    setTimeout(function () {
      if (rejected) return;
      dispatchRequest();
    }, action.delay);
  } else {
    if (rejected) return;
    dispatchRequest();
  }
}; // Redux middleware


var defaultOptions = {};
var debounceMap = new DebounceMap();

var apiMiddleware = function apiMiddleware() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  return function (store) {
    return function (next) {
      return function (action) {
        var requestHandler = action.type === API_REQUEST ? apiRequestHandler : action.type === MOCK_REQUEST ? mockRequestHandler : null;

        if (requestHandler) {
          return new Promise(function (resolve) {
            var processRequest = function processRequest() {
              return requestHandler(store, action, options, resolve);
            };

            if (action.debounce && action.requestType) {
              debounceMap.debounce(action.requestType, processRequest, Math.abs(action.debounce), {
                immediate: action.debounce < 0
              });
            } else {
              processRequest();
            }
          });
        }

        return next(action);
      };
    };
  };
};

var apiMiddleware$1 = apiMiddleware;

export { apiMiddleware$1 as default };
